import EducationsRoute from './EducationsRoute';

export default {
  name: 'EducationsRoute',
  location: '/lsp/educations',
  component: EducationsRoute,
};
